import React, { memo } from 'react';
import classNames from 'classnames/bind';
import { CheckIcon, ChevronDownIcon } from "../../../icons";
import style from "./styles.pcss";
var cn = classNames.bind(style);
export var OptionContentIcon = /*#__PURE__*/memo(function (_ref) {
  var active = _ref.active,
    toggleConfig = _ref.toggleConfig,
    icon = _ref.icon,
    disabled = _ref.disabled;
  return /*#__PURE__*/React.createElement("div", {
    className: cn('icon', {
      'icon--open': (toggleConfig === null || toggleConfig === void 0 ? void 0 : toggleConfig.isOpen) && !icon
    }),
    "data-t-id": "components-OptionContentIcon"
  }, active && /*#__PURE__*/React.createElement(CheckIcon, {
    className: cn('icon__inner'),
    size: "s"
  }), toggleConfig && icon && icon, toggleConfig && !icon && /*#__PURE__*/React.createElement(ChevronDownIcon, {
    className: cn('icon__inner-toggle', {
      'icon__inner--secondary': (toggleConfig === null || toggleConfig === void 0 ? void 0 : toggleConfig.theme) === 'secondary'
    }),
    fill: disabled ? '#A7ABB0' : '#13171b',
    size: "s"
  }));
});